export default __webpack_public_path__ + "assets/haze-day.fda09aa3.svg";